module.exports = __webpack_public_path__ + "static/img/caseImg14.de8c627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg14.jpg
// module id = 9RM0
// module chunks = 0